// Função que verifica se o usuário está autenticado
export const isAuthenticated = () => {
    // Verifica se o token está salvo no localStorage
    return localStorage.getItem('authId') !== null;
};
